import { Studio } from "./studio-model";

export class PasscultureHistorique {
  id?: number;
  code?: string;
  offer?: string;
  full_name?: string;
  phone_number?: string;
  email?: string;
  sms_gerant_sended?: boolean;
  sms_client_sended?: boolean;
  price?: number;
  studio?: Studio;
  createdAt?: string;
  nbr_hours?: number;
  studio_name?: string;
  nbr_hours_text?: string;

  constructor(data: Partial<PasscultureHistorique>) {
    if (data) {
      Object.assign(this, data);
      if (data.id !== undefined) {
        if (data.studio != undefined && data.studio != null) {
          this.studio = new Studio(data.studio as Partial<Studio>);
        }
      }
    }
  }

  static attributeToJson(item: any) {
    let obj = item.attributes;
    obj["id"] = item.id;
    if (item.attributes.studio) {
      if (item.attributes.studio.data != null) {
        let objStudio = item.attributes.studio.data.attributes;
        objStudio["id"] = item.attributes.studio.data.id;
        obj["studio"] = objStudio;
      } else {
        obj["studio"] = null;
      }
    } else {
      obj["studio"] = null;
    }
    obj["studio_name"] = (obj["studio"] != null) ? obj["studio"].name : "---";
    obj["nbr_hours_text"] = (obj["nbr_hours"] != null && obj["nbr_hours"] != 0) ? (obj["nbr_hours"]+"h") : "---";
    
    return obj;
  }
}
